<template>
  <base-module-modal
      v-if="this.config"
      :added-modules="initialModules"
      :modal-name="this.$options.name"
      :closing-offered="addedPassedModules"
      :confirmation-always-enabled="!addedPassedModules"
      :discarding-offered="addedPassedModules"
      :text-hint="textHint"
      :highlight-dark-blue="promptedPassedModules ? [] : expectedPassedModulesRequired"
      :highlight-blue="promptedPassedModules ? [] : expectedPassedModulesRecommended"
      @confirm-operation="updatePassedModules"
      icon-modal="task_alt"
      :modal-subtitle="`Select all that you will have passed by the beginning of the ${currentSemester}.`"
      modal-title="Select passed modules (current degree only)"
  >
  </base-module-modal>
</template>

<script>

import BaseModuleModal from "@/components/modals/BaseModuleModal.vue";
import {mapGetters, mapState} from "vuex";

export default {
  name: "PassedModulesModal",
  components: {BaseModuleModal},
  computed: {
    ...mapGetters(["addedPassedModules", "frontendCurrentSemester"]),
    ...mapState(["config", "preferences", "promptedPassedModules", "expectedPassedModulesRequired", "expectedPassedModulesRecommended"]),
    initialModules() {
      if (!this.promptedPassedModules && (this.expectedPassedModulesRequired.length > 0 || this.expectedPassedModulesRecommended.length > 0)) {
        return [...new Set([...this.preferences.passedModules, ...this.expectedPassedModulesRequired, ...this.expectedPassedModulesRecommended])];
      }
      return this.preferences.passedModules;
    },
    textHint() {
      if (this.expectedPassedModulesRequired.length > 0 || this.expectedPassedModulesRecommended.length > 0 || !this.promptedPassedModules) {
        return "Some of these modules are required or recommended to be passed by the beginning of the current semester. You may remove them from this list if you have not yet passed them.";
      }
      return this.preferences.degree === "msc" ? "If you cannot find a module, search for 'Special topic' (for " +
          "Mathematics) or 'Module' (for other Sciences) and select a module of the fitting area with the right " +
          "credit amount." : "";
    },
    currentSemester() {
      const semesterCode = this.frontendCurrentSemester;
      if (!semesterCode) return ""; 
      const season = semesterCode.startsWith("w") ? "winter semester" : "summer semester";
      const year = `20${semesterCode.slice(1)}`; 
      return `${season} ${year}`;
    }
  },
  methods: {
    updatePassedModules(markedModules) {
      const modulesToRemove = this.preferences.passedModules.filter(module => !markedModules.includes(module))
      const modulesToAdd = markedModules.filter(module => !this.preferences.passedModules.includes(module))
      modulesToRemove.forEach(module => {
        this.$store.commit("REMOVE_PASSED_MODULE", {passedModule:module, bulk:true});
      })
      modulesToAdd.forEach(module => {
        this.$store.commit("ADD_PASSED_MODULE", {passedModule: module, bulk:true});
      })

      if (!this.promptedPassedModules) {
        /* Temporary hack: sets max semester ECTS to 36 to counter workload-ects-discrepancy */
        this.hackSemesterPreferences();
      }
      this.$store.commit("SET_PROMPTED_PASSED_MODULES");
      this.$store.commit("SAVE_STATE");
      
    },
    hackSemesterPreferences() {
      if (this.preferences.degree === "bsc" && this.preferences.major === "mathematics"
          && ["w24", "s25"].includes(this.preferences.startSemester)
          && !this.preferences.passedModules.includes("MA0006")
          && !this.preferences.passedModules.includes("MA0007")) {
        const semester = this.preferences.startSemester === "w24" ? 2 : 1;
        this.$store.commit("UPDATE_SEMESTER_PREFERENCE", {semester: semester, key: "default", value: false, bulk: true});
        this.$store.commit("UPDATE_SEMESTER_PREFERENCE", {semester: semester, key: "maxEcts", value: 36, bulk: true});
      }
    }
  },
};
</script>

